import React from 'react';

import styled, { css } from 'styled-components';

import Icon from 'common/Icons/Icon';
import { testIdFormattedLabel } from 'components/ShopData/testIdUtils';

interface SplitButtonProps {
  content: string;
  onContentClick: () => void;
  onIconClick: () => void;
  type?: 'default' | 'primary';
}

const getBaseStyle = (type: 'default' | 'primary') => {
  if (type === 'primary') {
    return css`
      background-color: #1677ff;
      color: white;
    `;
  }
  return css`
    background-color: white;
    color: rgba(0, 0, 0, 0.88);
  `;
};

const getHoverStyle = (type: 'default' | 'primary') => {
  if (type === 'primary') {
    return css`
      background-color: #4096ff;
    `;
  }
  return css`
    background-color: rgba(0, 0, 0, 0.025);
  `;
};

const ButtonWrapper = styled.div`
  display: flex;
  border-radius: 15px;
  overflow: hidden;
  font-size: 12px;
  font-family: var(--font-bold);
  cursor: pointer;
  height: 26px;
  box-shadow: 0 2px 4px 0 var(--neutral-colors-white);
  border: 1px solid white;

  &.primary {
    border: 1px solid #4096ff;
  }
  &:hover {
    &.primary {
      border: 1px solid #4096ff;
    }
  }
`;

const ContentPart = styled.div<{ type: 'default' | 'primary' }>`
  padding: 0 10px;
  display: flex;
  align-items: center;
  ${(props) => getBaseStyle(props.type)}

  &:hover {
    ${(props) => getHoverStyle(props.type)}
  }
`;

const IconPart = styled.div<{ type: 'default' | 'primary' }>`
  padding: 0 8px;
  display: flex;
  align-items: center;
  border-left: 1px solid rgba(0, 0, 0, 0.06);
  ${(props) => getBaseStyle(props.type)}

  &:hover {
    ${(props) => getHoverStyle(props.type)}
  }
`;

const SplitButton: React.FC<SplitButtonProps> = ({ content, type = 'default', onContentClick, onIconClick }) => {
  const iconSrc = type === 'primary' ? '/icons/edit-white.svg' : '/icons/edit-black.svg';

  return (
    <ButtonWrapper className={type}>
      <ContentPart type={type} onClick={onContentClick}>
        {content}
      </ContentPart>
      {type === 'primary' && (
        <IconPart type={type} onClick={onIconClick} data-test-id={`edit-${testIdFormattedLabel(type)}`}>
          <Icon size={12} src={iconSrc} />
        </IconPart>
      )}
    </ButtonWrapper>
  );
};

export default SplitButton;
